import { render } from "./vuejs3-components-carousel.vue?vue&type=template&id=ede268e8&scoped=true"
import script from "./vuejs3-components-carousel.vue?vue&type=script&lang=js"
export * from "./vuejs3-components-carousel.vue?vue&type=script&lang=js"

import "./vuejs3-components-carousel.vue?vue&type=style&index=0&id=ede268e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede268e8"]])

export default __exports__